import APIAi from '@/api/modules/ai';

const initialState = {
  parsedClinic: {},
  textTemplates: [],
  requestResult: {},
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    parseClinic({ commit }, data) {
      return APIAi.parseClinic(data).then((response) => {
        if (response && response.data) {
          commit('SET_DATA', { type: 'parsedClinic', data: response.data });
        }
      });
    },
    getTextTemplates({ commit }, data) {
      return APIAi.getTextTemplates(data).then((response) => {
        if (response.data?.length) {
          commit('SET_DATA', { type: 'textTemplates', data: response.data });
        }
      });
    },
    getRequestResult({ commit }, params) {
      return APIAi.getRequestResult(params).then((response) => {
        if (response.data) {
          commit('SET_DATA', { type: 'requestResult', data: response.data });
        }
      });
    },
  },
};
